import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Card, Form, message, Row, Col, Select, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import { sectorService } from "../../../services/sector.service";
import { positionService } from "../../../services/position.service";
import CustomTextInput from "../../../components/CustomTextInput";
import { iscoService } from "../../../services/isco.service";
import useDebounce from "../../../hooks/useDebounce";

export default function PositionForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [keyword, setKeyword] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    keyword: null,
  });

  const { data: sectorals } = useQuery({
    queryKey: ["sectorals"],
    queryFn: () => sectorService.fetchAllWithoutPaginate(),
  });

  const { data: iscoData } = useQuery({
    queryKey: ["isco", dataParams],
    queryFn: () => iscoService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  });

  const { data } = useGetDetailApi({
    id,
    serviceFn: positionService.findById,
    queryKey: ["position"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: positionService,
    form: form,
    messageApi: messageApi,
    queryKey: "position",
    route: "/master-data/position",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data, sectorals]);

  const isPending = storeMutation.isLoading || updateMutation.isLoading;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      keyword: debouncedKeyword,
    }));
  }, [debouncedKeyword]);

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " Jabatan"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/position"}
            onClick={() => form.submit()}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Row gutter={[20]}>
            <Col span={24}>
              <Form.Item
                name="SectoralId"
                label={
                  <Typography.Text>
                    Sektoral
                    <Typography.Text style={{ color: "#940808" }}>
                      *
                    </Typography.Text>
                  </Typography.Text>
                }
                required={false}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  size="large"
                  options={sectorals?.data.map((e) => ({
                    label: e.name,
                    value: e.uuid,
                  }))}
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <CustomTextInput
                label="Jabatan"
                name="name"
                rules={[{ required: true, message: "Jabatan harus diisi" }]}
                disabled={isPending}
              />
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={<Typography.Text>Jabatan ISCO</Typography.Text>}
                name="iscoPosition"
              >
                <Select
                  size="large"
                  options={iscoData?.data?.map((e) => ({
                    label: e.position,
                    value: e.position,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
}
